import { Image, Pressable } from "react-native";
import React from "react";

interface Props {
  onPress: () => void;
}
const FilterIcon: React.FC<Props> = (props) => {
  const { onPress } = props;
  return (
    <Pressable onPress={onPress}>
      <Image
        source={require("assets/images/filter-icon.png")}
        style={{
          width: 30,
          height: 30,
        }}
      ></Image>
    </Pressable>
  );
};

export default FilterIcon;
